import { ApolloProvider } from '@apollo/client/react'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { PageTitleProvider } from './app/page-title.js'
import { createApolloClient } from './lib/apollo.js'
import { startAnalytics } from './lib/analytics.js'
import { router } from './router.js'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root')

/**
 * One client, handed to both React and the router.
 *
 * The router needs it because `beforeLoad` reads the viewer's preferred
 * language to decide what a language-less URL redirects to, and it has to read
 * the *same* cache the components read or the two can disagree about who is
 * signed in.
 */
const client = createApolloClient()
const stopAnalytics = startAnalytics(router)
import.meta.hot?.dispose(stopAnalytics)

createRoot(container).render(
  <StrictMode>
    <ApolloProvider client={client}>
      <PageTitleProvider>
        <RouterProvider router={router} context={{ client }} />
      </PageTitleProvider>
    </ApolloProvider>
  </StrictMode>,
)
